//permisions

export const modulesDataSI = [
     {
      "module": "okas inventory",
      "actions": ["view", "add","edit","delete","assign okas inventory"]
    },
     {
      "module": "distributor",
      "actions": ["view", "add","edit","delete"]
    },
     {
      "module": "si",
      "actions": ["view","edit"]
    },
     {
      "module": "subscription",
      "actions": ["view"]
    },
     {
      "module": "member license",
      "actions": ["view", "add","edit","delete","assign license"]
    },
     {
      "module": "master device",
      "actions": ["view", "add"]
    },
     {
      "module": "market place",
      "actions": ["view", "add","edit","delete"]
    },
    {
      "module": "support",
      "actions": ["reply", "view","request remote access","access design studio","share ticket"]
    },
    {
      "module": "version",
      "actions": ["view", "add","public version"]
    },
    {
      "module": "user",
      "actions": ["view","add","edit","delete"]
    },
    {
      "module": "role",
      "actions": ["view","add","edit","delete"]
    },
  ];